(function () {
    console.log("testing1 Logomark");

  const U = () => window.ProductDecoration.utils;

  function calc(ctx) {
    const detail = ctx.detail || {};
    const details = ctx.details || [];
    const qty = Number(ctx.qty || 0);
    const colorCount = Number(ctx.colorCount || 0);
    const imprintLocationCount = detail.imprintLocationCount || (details.findIndex(d => d.sectionKey == detail.sectionKey) + 1);

    const imprintTypes = String(detail.imprint_type || "").toLowerCase();

    const setupPriceFallback = Number(ctx.setupPrice || 0);
    const runPriceFallback = Number(ctx.runPrice || 0);

    // Pull charges (best effort; won’t affect your current totals if absent)
    const decorationData = ctx.decorationData;
    const matched = U().findDecorationEntry(decorationData, details, detail, imprintTypes);
    const charges = matched?.charges || [];

    const setupList = charges.flat().filter((c) => c?.type === "Setup");
    const runList = charges.flat().filter((c) => c?.type === "Run");

    let setupobj = null;
    let runobj = null;

    const pickSetup = () =>
      setupList.find((c) => String(c?.y_min_qty) === "*") ||
      U().pickMaxPrice(setupList) ||
      null;

    const pickRunTiered = () => {
      const tier = U().closestLowerTierQty(qty, runList);
      return (
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList) ||
        null
      );
    };

    // ========= GROUP 1 =========
    // badgeworx, colorsplash, full color transfer, ...
    if (
      [
        "badgeworx",
        "laserxtreme",
        "full color dome",
        "colorsplash",
        "full color transfer",
        "full color vinyl",
      ].includes(imprintTypes)
    ) {
      setupobj = pickSetup();
      runobj = pickRunTiered();

      const totalSetupCharge = setupPriceFallback;
      const totalRunCharge = runPriceFallback * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    if (
      [
        "laser engraving",
        "etched",
        "laser & oxidation",
      ].includes(imprintTypes)
    ) {
      setupobj = pickSetup();
      runobj = pickRunTiered();

      const totalSetupCharge = setupPriceFallback;
      const totalRunCharge = runPriceFallback * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }


    // ========= GROUP 2 =========
    // debossing, bugatti digital, etc.
    if (
      [
        "debossing",
      ].includes(imprintTypes)
    ) {
      setupobj = pickSetup();
      runobj = pickRunTiered();

      const totalSetupCharge = setupPriceFallback;
      const totalRunCharge = runPriceFallback * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    if (
      [
        "debossing (bugatti)",
        "full color case (kameleon)",
        "full color digital (bugatti)",
      ].includes(imprintTypes)
    ) {
      setupobj = pickSetup();
      runobj = pickRunTiered();

      const totalSetupCharge = setupPriceFallback;
      const totalRunCharge = runPriceFallback;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }


    // ========= GROUP 3 =========
    // dye-sublimation
    if (["dye-sublimation"].includes(imprintTypes)) {
      setupobj = pickSetup();
      runobj = pickRunTiered();

      const totalSetupCharge = setupPriceFallback;
      const totalRunCharge = runPriceFallback;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // ========= Embroidery =========
    if (["embroidery"].includes(imprintTypes)) {
      setupobj = pickSetup();
      runobj = pickRunTiered();

      const totalSetupCharge = setupPriceFallback;
      const totalRunCharge = runPriceFallback * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // ========= Embroidery (bugatti) =========
    if (["embroidery (bugatti)"].includes(imprintTypes)) {
      setupobj = pickSetup();
      runobj = pickRunTiered();

      const totalSetupCharge = setupPriceFallback;
      const totalRunCharge = runPriceFallback * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // ========= Pad print / Screen printing =========
    if (["pad print", "screen printing"].includes(imprintTypes)) {
      setupobj = pickSetup();
      runobj = pickRunTiered();

      const totalSetupCharge = setupPriceFallback * colorCount;
      const totalRunCharge =
        runPriceFallback * Math.max(colorCount - 1, 0) * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // ========= Custom mold =========
    if (["custom mold"].includes(imprintTypes)) {
      setupobj = pickSetup();
      runobj = pickRunTiered();
      const totalSetupCharge = setupPriceFallback * colorCount;
      const totalRunCharge = runPriceFallback;
      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // ========= Xtreme wrap =========
    if (["xtreme wrap"].includes(imprintTypes)) {
      setupobj = pickSetup();
      runobj = pickRunTiered();
      const totalSetupCharge = setupPriceFallback * colorCount;
      const totalRunCharge = runPriceFallback * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // ========= Fallback =========
    setupobj = pickSetup();
    runobj = pickRunTiered();

    return {
      totalSetupCharge: setupPriceFallback,
      totalRunCharge: runPriceFallback * qty,
      setupobj,
      runobj,
    };
  }

  const supplier = {
    calcOnQty: calc,
    calcOnColor: calc,
  };

  window.ProductDecoration.registerSupplier("logomark", supplier);
  window.ProductDecoration.registerSupplier("Logomark", supplier);

  console.log("Registered Logomark supplier handler");
})();
